import { createContext } from 'react';
import { FontSize } from '../hooks/useFontSizeSettings';

export interface FontSizeContextValue {
  selectedFontSize: FontSize;
  scaleFontSize: (baseFontSize: string) => string;
  handleFontSizeSelect: (fontSize: FontSize) => void;
}

export const FontSizeContext = createContext<FontSizeContextValue | undefined>(
  undefined
);
